import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';

export const makeFormPanelStyles = makeStyles(
    (theme: Theme) => ({
        componentWrapper: {
            paddingLeft: '1rem',

            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
            },
        },
        formPanel: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',

            '& img': {
                height: '5rem',
                margin: '2rem auto 0',
            },
        },
        formPanelTitle: {
            fontSize: '1.375rem',
            zIndex: 1
        },
        formPanelWrapper: {
            borderRight: '0.0625rem solid lightgray',

            [theme.breakpoints.down('sm')]: {
                borderRight: 0,
                background: 'lightgrey'
            },
        },
        formPanelTile: {
            [theme.breakpoints.down('sm')]: {
                marginBottom: 16,
                padding: '0 15px'
            }
        }
    }),
    { index: 1 },
);
